import React from 'react'
import { useSelector } from 'react-redux'
import 'hammerjs'
import BalanceChart from './Charts/BalanceChart'
import BalanceTable from './Tables/BalanceTable'

import ConnectButton from 'components/Common/Button/ConnectButton'
import ZendeskLink from 'components/Common/ZendeskLink'
import { Link, Typography } from '@mui/material'

import FinancialOverviewPlaceholder from './FinancialOverviewPlaceholder'

function BalanceTab() {
  const graphImage = process.env['REACT_APP_BRC_IMAGE_URL'] + '/svg/cashflow_popup_cashflow.svg'
  const tableImage =
    process.env['REACT_APP_BRC_IMAGE_URL'] + '/svg/cashlow_popup_cashflow_invoices_table.svg'
  const codatConnected = useSelector(state => state.appReducer.accountCodatConnected)
  return (
    <div className="d-flex flex-column h-100 k-relative">
      {codatConnected && <BalanceChart />}
      {codatConnected && <BalanceTable />}
      {!codatConnected && (
        <FinancialOverviewPlaceholder isWithDropPlaceholder graphImage={graphImage} tableImage={tableImage} />
      )}
      {!codatConnected && (
        <div className=" bg-transparent border-light align-text-bottom text-center mt-3 px-3">
          <ConnectButton label="Connect your accounting application" isConnected={codatConnected} />
          <p className="pb-3 disclaimer-text">
            When you connect your accounting application you will see your past transactions.
          </p>
        </div>
      )}
      <div className="dialog-markaaz-payment-container position-relative text-center">
        <div className="markaaz-payments-link-container">
          <p className="p-3 mb-0" style={{ color: '#25245f' }}>
            <span className="px-1">
              <b>COMING SOON:</b>
            </span>
            pay and get paid through Markaaz.
            <span className="px-1">
              <Link
                rel="noreferrer noopener"
                href="https://markaaz.com/blog/"
                target="_blank"
                underline="hover"
                className="markaaz-payments-link"
              >
                <Typography component="span" variant="body2B" color="secondary">
                  Learn more about Payments coming soon!
                </Typography>
              </Link>
            </span>
          </p>
          <div className="link-hover-message">
            Paying and getting paid on Markaaz is different than anywhere else. Markaaz has negotiated the best rates on
            your behalf for every transaction. Learn more about payments coming soon!
          </div>
        </div>
      </div>

      <ZendeskLink />
    </div>
  )
}

export default BalanceTab
